// extracted by mini-css-extract-plugin
export var active = "_85-2";
export var container = "_85-0";
export var expired = "_85-3";
export var hasStatus = "_85-4";
export var statusChip = "_85-1";